import ADP_LOGO from "../assets/logo-adp.png";
import BAMBOO_LOGO from "../assets/logo-bamboo.png";
import BIGIN_LOGO from "../assets/logo-bigin.png";
import BRAINTREE_LOGO from "../assets/logo-braintree.png";
import DOCSIGN_LOGO from "../assets/logo_docsign.png";
import FRESHBOOKS_LOGO from "../assets/logo-freshbooks.png";
import FRESHSALES_LOGO from "../assets/logo-freshsales.png";
import HUBSPOT_LOGO from "../assets/logo-hubspot.png";
import NAMELY_LOGO from "../assets/logo-namely.png";
import NETSUITE_LOGO from "../assets/logo-netsuite.png";
import PIPEDRIVE_LOGO from "../assets/logo-pipedrive.png";
import QUICKBOOK_LOGO from "../assets/logo-quickbook.png";
import SAGEINTACCT_LOGO from "../assets/logo-sage-intacct.png";
import SF_LOGO from "../assets/logo-sf.png";
import SLACK_LOGO from "../assets/logo-slack.png";
import STRIPE_LOGO from "../assets/logo-stripe.png";
import XERO_LOGO from "../assets/logo-xero.png";
import ZAPIER_LOGO from "../assets/logo-zapier.png";
import ZENDESK_LOGO from "../assets/logo-zendesk.png";
import ZOHO_LOGO from "../assets/logo-zoho-crm.png";

import { FEATURES_NAME } from "./features";

export const SETTINGS_ACCOUNT = "account";
export const SETTINGS_BILLING = "billing";
export const SETTINGS_PROFILE = "profile";
export const SETTINGS_TEAMMATES = "teammates";
export const SETTINGS_ROLES = "roles";
export const SETTINGS_INTEGRATIONS = "integrations";
export const SETTINGS_AUTHENTICATION = "authentication";
export const SETTINGS_REVV_OAUTH = "revv-api";
export const DOCSIGN_LOGO_INFO = DOCSIGN_LOGO;

// Billing Plan Types
export const FREE_TRAIL = "essentials";
export const ENTERPRISE = ["enterprise-monthly", "enterprise-annual"];

const SETTINGS = {
  MANAGE_COMPANY_SETTINGS: "manage_company_settings",
  MANAGE_TEAMMATES: "manage_teammates",
  MANAGE_ROLES: "manage_roles",
  CONFIGURE_INTEGRATIONS: "configure_integrations",
  MANAGE_AUTHENTICATIONS: "manage_authentications",
};

export const SETTINGS_VIEWS = [
  {
    name: "Profile settings",
    settingsView: SETTINGS_PROFILE,
    fullpath: "/settings/profile",
    faStyle: "far",
    faIcon: "user-ninja",
  },
  {
    name: "Account settings",
    settingsView: SETTINGS_ACCOUNT,
    fullpath: "/settings/account",
    faStyle: "far",
    faIcon: "building",
    readPermission: SETTINGS.MANAGE_COMPANY_SETTINGS,
  },
  {
    name: "Billing",
    settingsView: SETTINGS_BILLING,
    fullpath: "/settings/billing",
    faStyle: "far",
    faIcon: "badge-dollar",
  },
  {
    name: "Users",
    settingsView: SETTINGS_TEAMMATES,
    fullpath: "/settings/teammates",
    faStyle: "far",
    faIcon: "users",
    readPermission: SETTINGS.MANAGE_TEAMMATES,
  },
  // {
  //   name: "Roles",
  //   settingsView: SETTINGS_ROLES,
  //   fullpath: "/settings/roles",
  //   faStyle: "far",
  //   faIcon: "user-tag",
  //   readPermission: SETTINGS.MANAGE_ROLES,
  // },
  {
    name: "Integrations",
    settingsView: SETTINGS_INTEGRATIONS,
    fullpath: "/settings/integrations",
    faStyle: "far",
    faIcon: "exchange-alt",
    readPermission: SETTINGS.CONFIGURE_INTEGRATIONS,
  },
  // {
  //   name: "Authentication",
  //   settingsView: SETTINGS_AUTHENTICATION,
  //   fullpath: "/settings/authentication",
  //   faStyle: "far",
  //   faIcon: "key",
  //   readPermission: SETTINGS.MANAGE_AUTHENTICATIONS,
  // },
  {
    name: "Revv API",
    settingsView: SETTINGS_REVV_OAUTH,
    fullpath: "/settings/revv-api",
    faStyle: "far",
    faIcon: "key",
  },
];

export const SETTINGS_DEFAULT_VIEW_URL = SETTINGS_VIEWS[0].settingsView;

export const CRM_TYPES = {
  OAUTH: "OAUTH",
  USERID: "USERID",
  ESIGN: "ESIGN",
  ZAPIER: "ZAPIER",
  STRIPE: "STRIPE",
};

// for CRM url parameter
// ex: /settings/integrations/salesforce
export const CRM_URL_PARAMS = {
  SALESFORCE: "salesforce",
  ZOHO: "zoho",
  DOCUSIGN: "docusign",
  ZAPIER: "zapier",
  STRIPE: "stripe",
};

export const CRM_NAMES = {
  SALESFORCE: "Salesforce",
  ZOHO: "Zoho CRM",
  DOCUSIGN: "Docusign",
  ZAPIER: "Zapier",
  STRIPE: "Stripe",
};

export const CRM_SHORT_NAMES = {
  SALESFORCE: "SF",
  ZOHO: "ZO",
  DOCUSIGN: "DS",
  ZAPIER: "ZA",
  STRIPE: "SE",
};

// crm config mappings related all constants
export const CRM_LOGOS_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: SF_LOGO,
  [CRM_URL_PARAMS.ZOHO]: ZOHO_LOGO,
  [CRM_URL_PARAMS.DOCUSIGN]: DOCSIGN_LOGO,
  [CRM_URL_PARAMS.ZAPIER]: ZAPIER_LOGO,
  [CRM_URL_PARAMS.STRIPE]: STRIPE_LOGO,
};

export const CRM_NAMES_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: CRM_NAMES.SALESFORCE,
  [CRM_URL_PARAMS.ZOHO]: CRM_NAMES.ZOHO,
  [CRM_URL_PARAMS.DOCUSIGN]: CRM_NAMES.DOCUSIGN,
  [CRM_URL_PARAMS.ZAPIER]: CRM_NAMES.ZAPIER,
  [CRM_URL_PARAMS.STRIPE]: CRM_NAMES.STRIPE,
};

export const CRM_SHORT_NAMES_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: CRM_SHORT_NAMES.SALESFORCE,
  [CRM_URL_PARAMS.ZOHO]: CRM_SHORT_NAMES.ZOHO,
  [CRM_URL_PARAMS.DOCUSIGN]: CRM_SHORT_NAMES.DOCUSIGN,
};

export const CRM_TYPES_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: CRM_TYPES.OAUTH,
  [CRM_URL_PARAMS.ZOHO]: CRM_TYPES.OAUTH,
  [CRM_URL_PARAMS.DOCUSIGN]: CRM_TYPES.ESIGN,
  [CRM_URL_PARAMS.ZAPIER]: CRM_TYPES.ZAPIER,
  [CRM_URL_PARAMS.STRIPE]: CRM_TYPES.STRIPE,
};

export const CRM_INTEGRATIONS = [
  {
    name: CRM_NAMES[CRM_URL_PARAMS.SALESFORCE],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.SALESFORCE],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.SALESFORCE}`,
    logopath: SF_LOGO,
    featureName: FEATURES_NAME.INTG_SALESFORCE_STANDARD,
  },
  {
    name: CRM_NAMES[CRM_URL_PARAMS.ZOHO],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.ZOHO],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.ZOHO}`,
    logopath: ZOHO_LOGO,
    featureName: FEATURES_NAME.INTG_ZOHO,
  },
  {
    name: CRM_NAMES[CRM_URL_PARAMS.ZAPIER],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.ZAPIER],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.ZAPIER}`,
    logopath: ZAPIER_LOGO,
    featureName: FEATURES_NAME.INTG_ZAPIER,
  },
  {
    name: CRM_NAMES[CRM_URL_PARAMS.STRIPE],
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.STRIPE],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.STRIPE}`,
    logopath: STRIPE_LOGO,
    featureName: FEATURES_NAME.INTG_STRIPE,
  },
  // {
  //   name: CRM_NAMES[CRM_URL_PARAMS.DOCUSIGN],
  //   id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.DOCUSIGN],
  //   fullpath: `/settings/integrations/${CRM_URL_PARAMS.DOCUSIGN}`,
  //   logopath: DOCSIGN_LOGO,
  //   version: "beta",
  // },
];

// Teammates Settings
export const USER_GROUPS = ["Deal Desk", "Legal", "Sales"];

// INTEGRATION SETTINGS PAGE

// ! Do not change the order
export const UPCOMING_INTEGRATIONS = [
  SLACK_LOGO,
  BRAINTREE_LOGO,
  ZENDESK_LOGO,
  ADP_LOGO,
  BAMBOO_LOGO,
  BIGIN_LOGO,
  FRESHBOOKS_LOGO,
  FRESHSALES_LOGO,
  HUBSPOT_LOGO,
  NAMELY_LOGO,
  QUICKBOOK_LOGO,
  XERO_LOGO,
  SAGEINTACCT_LOGO,
  NETSUITE_LOGO,
  PIPEDRIVE_LOGO,
  DOCSIGN_LOGO,
];



// WEBPACK FOOTER //
// ./src/constants/settings.js